<template>
  <v-container class="pa-0">
    <v-layout>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="list"
          :items-per-page="10"
          class="elevation-1"
          locale="pt-br"

        >
         <template v-slot:item.action="{ item }">
          <v-icon
            @click="getAnswers(item.id)"
          >
            mdi-eye
          </v-icon>
        </template></v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog v-model="open" :width="answers === null ? '100px' : '100%'">
       <v-tooltip bottom v-if="answers !== null">
          <template v-slot:activator="{ on }">
            <v-btn  v-on="on" @click="print()" fab fixed right bottom class="mb-10 mr-10" color="primary" :loading="loading">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          </template>
          <span>Imprimir</span>
        </v-tooltip>
        <ReviewQuestions ref="review" :questions="answers" :loading="answers === null"/>
        <iframe v-if="iframe" @load="callPrint" id="printf" name="printf" :srcdoc="iframe" frameborder="0">
        </iframe>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import ReviewQuestions from '@/components/ReviewQuestions'
export default {
  components: {
    ReviewQuestions
  },
  data () {
    return {
      answers: null,
      open: false,
      iframe: null,
      loading: false,
      headers: [
        // { text: 'Email', value: 'email' },
        { text: 'Data', value: 'date' },
        { text: '', value: 'action', sortable: false, align: 'right' }
      ]
    }
  },
  methods: {
    print () {
      this.loading = true
      this.iframe = `<head><link href="https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css" rel="stylesheet"></head>${this.$refs.review.$el.outerHTML}`
    },
    callPrint () {
      this.loading = false
      window.frames['printf'].focus()
      window.frames['printf'].print()
      setTimeout(() => {
        this.iframe = null
      }, 3000)
    },
    async getAnswers (value) {
      this.answers = null
      this.open = true
      const { data: result } = await axios.get('/GetQuestionarioById', {
        params: {
          idQuestionario: value
        }
      })
      result['email'] = 'Indisponível'
      this.answers = this.questions.map(elem => {
        return {
          ...elem,
          value: result[elem.field]
        }
      })
    }
  },
  computed: {
    ...mapGetters('auth', ['list']),
    ...mapGetters('form', ['questions'])
  }
}
</script>

<style>

</style>
